import { useRef, useCallback, useEffect } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { showBadge } from '../core/controller.js';
import { RECAPTCHA_ACTION, CYPRESS_FLAG, RECAPTCHA_FALLBACK_TOKEN, RECAPTCHA_TOKEN } from '../index.js';

const useReCaptcha = ({ action, badge })=>{
    const { executeRecaptcha } = useGoogleReCaptcha();
    const shouldShowBadge = useRef(badge);
    /**
     * Execute client side reCAPTCHA request and inject token to the callbacks.
     */ const withReCaptcha = useCallback(async ({ onCompleted, onError })=>{
        let isAutomation = false;
        try {
            // Check if the parent window is Cypress or Playwright, or if the browser is in automation mode.
            isAutomation = typeof window.parent.Cypress !== 'undefined' || typeof window.parent.__isPlaywright !== 'undefined' || window.parent.navigator.webdriver;
        } catch  {
        // Error is ignored in case of a cross-origin parent
        }
        if (isAutomation) {
            return await onCompleted?.({
                headers: {
                    [CYPRESS_FLAG]: true,
                    [RECAPTCHA_ACTION]: action
                }
            });
        }
        // Check if the reCAPTCHA client is ready
        if (executeRecaptcha == null) {
            if (onError != null) {
                return await onError();
            }
            return await onCompleted?.({
                headers: {
                    [RECAPTCHA_TOKEN]: RECAPTCHA_FALLBACK_TOKEN,
                    [RECAPTCHA_ACTION]: action
                }
            });
        }
        let token = undefined;
        // Request client token from Google with reCAPTCHA client
        try {
            token = await executeRecaptcha(action);
        } catch (error) {
            if (onError != null) {
                return await onError(error);
            }
        }
        await onCompleted?.({
            headers: {
                [RECAPTCHA_TOKEN]: token ?? RECAPTCHA_FALLBACK_TOKEN,
                [RECAPTCHA_ACTION]: action
            }
        });
    }, [
        action,
        executeRecaptcha
    ]);
    useEffect(()=>{
        // Turn on reCAPTCHA badge when the initial value of badgeVisible is `true`
        if (shouldShowBadge.current) {
            return showBadge();
        }
    }, []);
    return {
        withReCaptcha
    };
};

export { useReCaptcha };
//# sourceMappingURL=hook.js.map
